/* unplugin-vue-components disabled */import { render } from "./LeftGroupList.vue?vue&type=template&id=ef0f468e&scoped=true"
import script from "./LeftGroupList.vue?vue&type=script&lang=js"
export * from "./LeftGroupList.vue?vue&type=script&lang=js"

import "./LeftGroupList.vue?vue&type=style&index=0&id=ef0f468e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef0f468e"]])

export default __exports__